import styled from "styled-components"

export default styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  border: 1px solid #ccc;
  height: 80px;
  border-radius: 5px;
  margin-right: 20px;
  padding: 4px;
`
